import api from 'common/api';

export const loginAPI = (params: any) => api.post('/auth/login', params);

export const changePasswordAPI = (params: any) => api.post('/auth/change-password', params);

export const authorityApi = (params?: any) => api.get('/auth/authority', params);
